import { render } from "./MyStacks.vue?vue&type=template&id=63b92ebe&scoped=true&ts=true"
import script from "./MyStacks.vue?vue&type=script&lang=ts"
export * from "./MyStacks.vue?vue&type=script&lang=ts"

import "./MyStacks.vue?vue&type=style&index=0&id=63b92ebe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b92ebe"]])

export default __exports__